<div class="k-row">
    <div style="
          float: right;
          display:inline;
          text-align:right;
          padding-bottom: 10px;
          padding-top: 10px;" class="ng-star-inserted">
        <button
                class="k-generic-btn ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only"
                *ngIf="idDetails!=0"
                (click)="togleClassificationList($event)"
                style="height: 40px;"
                pButton
                type="button"
                label="{{labelButtonBack}}">
        </button>
    </div>
</div>

<app-classification-list
        (customButton)="togleClassificationList($event)"
        *ngIf="idDetails==0"
    >
</app-classification-list>

<app-common-classification-details
        [idDetails]="idDetails"
        *ngIf="idDetails!=0"
    >
</app-common-classification-details>


// WEBPACK FOOTER //
// ./src/app/views/classification/classification.component.html